import { render, staticRenderFns } from "./counselorlogin.vue?vue&type=template&id=fac6c6b8&scoped=true&"
import script from "./counselorlogin.vue?vue&type=script&lang=js&"
export * from "./counselorlogin.vue?vue&type=script&lang=js&"
import style0 from "./counselorlogin.vue?vue&type=style&index=0&id=fac6c6b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac6c6b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VContainer,VFlex,VImg,VLayout,VTextField})
